import { render } from "./Stonemason.vue?vue&type=template&id=47810fa6"
import script from "./Stonemason.vue?vue&type=script&lang=js"
export * from "./Stonemason.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Stonemason.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47810fa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47810fa6', __exports__)) {
    api.reload('47810fa6', __exports__)
  }
  
  module.hot.accept("./Stonemason.vue?vue&type=template&id=47810fa6", () => {
    api.rerender('47810fa6', render)
  })

}


export default __exports__